import { useQuery } from '@tanstack/react-query';
import { queries } from '../../queries';
import type { IServicePlan } from '../../types/plan';

export default function useGetPlanDetails({
  id,
  onSuccess,
}: {
  id: number;
  onSuccess?: (data: IServicePlan | null) => void;
}) {
  return useQuery({
    ...queries.plans.planDetails({ id }),
    enabled: !!id,
    select: (data) => data?.data ?? null,
    onSuccess,
  });
}
